export enum AsyncTaskStatus {
  Blocked = 0,
  Pending = 1,
  Running = 2,
  Completed = 3,
  Failed = 4,
}

export enum AsyncTaskType {
  ScanAws = 'scan-aws',
  LoadAzure = 'load-azure',
  ScanKubernetes = 'scan-kubernetes',
}

export interface AsyncTaskInfo {
  id: number;
  status: AsyncTaskStatus;
  type: AsyncTaskType;
  entityId?: string;
  errorMessage?: string;
  progress: number;
  createdAt: string;
  updatedAt: string;
}

export interface AsyncTaskJobDefinition {
  name: string;
  dependsOn: string[];
  taskFinalJob: boolean;
  startTimeout: number;
}

export interface AsyncTaskStructure {
  type: AsyncTaskType;
  jobs: AsyncTaskJobDefinition[];
}

export interface AsyncTaskSchedulerInfo {
  name: string;
  targetTaskType: AsyncTaskType;
  cron: string;
  entityId: string;
}
